import { emptyApi } from "./emptyApi";

export type MeetingRequestPayload = {
  team: number;
  channel_url: string;
  calendly_link: string;
  final_message: string;
  purpose?: string;
  task_id?: string;
  ai_generated_message?: string;
};

export type MeetingAIDraftPayload = {
  team: number;
  client_name?: string;
  calendly_link: string;
  purpose?: string;
  task_context?: string;
};

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    createMeetingRequest: build.mutation<
      { meeting_request_id: string },
      { groupId: string; payload: MeetingRequestPayload }
    >({
      query: ({ groupId, payload }) => ({
        url: `/api/inkle/messaging/group/${groupId}/meeting-request/`,
        method: "POST",
        body: payload,
      }),
    }),
    getMeetingRequestAIDraft: build.mutation<
      { message: string },
      { groupId: string; payload: MeetingAIDraftPayload }
    >({
      query: ({ groupId, payload }) => ({
        url: `/api/inkle/messaging/group/${groupId}/meeting-request/ai-draft/`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateMeetingRequestMutation,
  useGetMeetingRequestAIDraftMutation,
} = extendedApi;
